import type { Invoice } from "@freightsimple/generated-dashboard-openapi-client/models/Invoice";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";
import { shouldBePaid } from "../../Helpers/paymentsMakePaymentsUtils";

/**
 * The invoices the Make Payments dialog will actually list.
 *
 * Exported so a screen can ask the question before offering the button. The
 * dialog and the button that opens it have to agree: an unpaid *refund* is
 * still money owed but is not something a customer pays, so gating the button
 * on "unpaid" alone opens the dialog on "You're all caught up".
 */
export function paymentsPayableInvoices(
  invoices: Invoice[],
  shipments: Shipment[],
): Invoice[] {
  // Only booked shipments are loaded, and the table can't render a row
  // without one, so an invoice whose shipment is missing isn't payable here.
  const shipmentIds = new Set(shipments.map((s) => s.shipmentId));
  return invoices.filter(
    (invoice) => shouldBePaid(invoice) && shipmentIds.has(invoice.shipmentId),
  );
}
